/**
 * Client Entry Point - Universal Rendering
 *
 * - SSR routes: hydrateRoot (questions pages)
 * - CSR routes: createRoot (home page)
 */

import './index.css'
import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import App from './App'
import '@/shared/types/global.d.ts'

const rootElement = document.getElementById('root')!
const initialData = window.__INITIAL_DATA__ || undefined

// Detect if server rendered HTML exists
const hasServerRenderedContent = rootElement.innerHTML.trim() !== ''

if (hasServerRenderedContent) {
  // SSR route: hydrate existing server HTML
  console.log('[Hydration] SSR detected, using hydrateRoot')
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App initialData={initialData} />
    </StrictMode>
  )
} else {
  // CSR route: render from scratch
  console.log('[Hydration] CSR detected, using createRoot')
  createRoot(rootElement).render(
    <StrictMode>
      <App initialData={initialData} />
    </StrictMode>
  )
}
